import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { Link, useNavigate } from 'react-router-dom';
import logo from '../assets/logo.png';
import Modal, { useModal } from '../components/Modal';
import LoadingOverlay from '../components/LoadingOverlay';

export default function LoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const { modal, show, close } = useModal();
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      navigate('/');
    } catch (err: any) {
      show({ title: 'Accesso non riuscito', message: err.response?.data?.message || 'Email o password non corretti.', type: 'error', onConfirm: close });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', background: 'var(--bg)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px' }}>
      <div style={{ width: '100%', maxWidth: 390, display: 'flex', flexDirection: 'column', gap: 24 }}>

        {/* Logo */}
        <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 8 }}>
          <img src={logo} alt="Molti Like" style={{ width: 220, height: 'auto', objectFit: 'contain' }} />
        </div>

        {/* Heading */}
        <div style={{ textAlign: 'center' }}>
          <p style={{ fontSize: 22, fontWeight: 700, color: 'var(--text-1)', marginBottom: 6, letterSpacing: '-0.02em' }}>Bentornato</p>
          <p className="sub">Accedi al tuo account</p>
        </div>

        {loading && <LoadingOverlay title="Accesso in corso..." subtitle="Un momento" icon="login" />}
        {modal && <Modal isOpen title={modal.title} message={modal.message} type={modal.type} confirmText={modal.confirmText} cancelText={modal.cancelText} onConfirm={modal.onConfirm} onCancel={modal.onCancel ?? close} />}

        {/* Form */}
        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          <div className="form-group">
            <label className="form-label">Email</label>
            <input
              className="form-input"
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              placeholder="mario@esempio.com"
              autoComplete="email"
              required
            />
          </div>

          <div className="form-group">
            <label className="form-label">Password</label>
            <input
              className="form-input"
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              placeholder="••••••••"
              autoComplete="current-password"
              required
            />
          </div>

          <div style={{ textAlign: 'right' }}>
            <Link to="/forgot-password" style={{ fontSize: 13, color: 'var(--primary)', fontWeight: 500, textDecoration: 'none' }}>
              Password dimenticata?
            </Link>
          </div>

          <button type="submit" className="btn btn-primary" disabled={loading} style={{ marginTop: 4 }}>
            Accedi
          </button>
        </form>

        <p style={{ textAlign: 'center', fontSize: 13, color: 'var(--text-2)' }}>
          Non hai un account?{' '}
          <Link to="/register" style={{ color: 'var(--primary)', fontWeight: 600, textDecoration: 'none' }}>
            Registrati
          </Link>
        </p>
      </div>
    </div>
  );
}
